"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var material_1 = require("@mui/material");
var styles_1 = require("@mui/material/styles");
var DefaultPropsHoC_1 = __importDefault(require("components/Generic/DefaultPropsHoC"));
var StyledAccordion = (0, styles_1.styled)(material_1.Accordion)(function (_a) {
    var theme = _a.theme;
    return ({
        boxShadow: 'none',
        '&.Mui-disabled': {
            background: 'none',
            '& .Mui-disabled': {
                opacity: 1,
            },
        },
        '&::before': {
            background: theme.palette.common.white,
        },
        // borderTop: showBorders ? '1px solid transparent' : 'none',
        // borderBottom: showBorders ? '1px solid transparent' : 'none',
        borderRadius: 0,
        '&.MuiAccordion-root.Mui-expanded': {
            // borderTop: showBorders ? `1px solid ${theme.palette.grey[600]}` : 'none',
            // borderBottom: showBorders ? `1px solid ${theme.palette.grey[600]}` : 'none',
            borderRadius: 0,
            minHeight: 'auto',
            margin: 0,
        },
    });
});
exports.default = (0, DefaultPropsHoC_1.default)(StyledAccordion, { TransitionProps: { timeout: 0 } });
